import { notify } from 'src/plugins/notify'
import { api } from 'src/plugins/axios'

export default {
    verifyCode,
    completeRegistration
}

async function verifyCode({state}){
    state.verifying = true
    let { data } = await api.post('/calendar/verifyCode',{CLASS_CODE:state.classCode})

    let message = data.message
    if(data.success){
        state.sessions = data.payload.sessions
        console.log(data.payload)
        state.class = data.payload.class
        notify.create({
            message: message,
            type:'positive'
        })
        state.verifying = false
    }
    else{
        state.sessions = null
        state.class = null
        notify.create({
            message: message,
            type:'negative'
        })
        state.verifying = false
    }
}

async function completeRegistration({state, commit}){
    let { data: response } = await api.post('/calendar/completeStudentRegistration',{
        CLASS_CODE: state.classCode,
        SESSIONS: state.selectedSession,
        CLASS_ID: state.class.CLASS_ID,
        STUDENT: {
            STUDENT_FIRST_NAME: state.student.firstName,
            STUDENT_MIDDLE_NAME: state.student.middleName,
            STUDENT_LAST_NAME: state.student.lastName,
            STUDENT_DOB: state.student.dob,
            STUDENT_GENDER: state.student.gender,
            STUDENT_PHONE: state.student.phone,
            STUDENT_EMAIL: state.student.email         
        },
        DRIVERS_LICENSE: {
            DRIVERS_LICENSE: state.student.dl,
            LK_STATE_ID: state.student.dl_state
        },
        ADDRESS:{
            ADDRESS_1: state.student.address1,
            CITY:state.student.city,
            LK_STATE_ID :state.student.state,
            ZIP_CODE: state.student.zip
        }
    })

    const { success, payload } = response
    console.log(success, payload)
    if(success){
        state.studentEntry = false
        commit('completeSignup')
    }
    notify.create({
        message: response.message || payload.message,
        type: success ? 'positive' : 'negative'
    })
}